import Swiper from 'swiper';

new Swiper('.front-page__header__carousel', {
  effect: 'fade',
  loop: true,
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.front-page__header__carousel__navigation .swiper-button-next',
    prevEl: '.front-page__header__carousel__navigation .swiper-button-prev',
  },
  pagination: {
    el: '.front-page__header__carousel .swiper-pagination',
    clickable: true,
  },
});
